import { Injectable } from '@angular/core';
import { ServerConnectionService } from '../server-connection.service';
import { CoreModule } from '../../core.module';
import { BooksService } from './books.service';

@Injectable({
	providedIn: CoreModule,
})
export class AuthorService {
	constructor(
		private scs: ServerConnectionService,
		private booksService: BooksService,
	) { }

	importBooksFromAuthor(body) {
		return this.scs.http$('POST', '/api/author/fetch', null, body);
	}

	removeBooksFromAuthor(body) {
		return this.scs.http$('POST', '/api/author/remove-books', null, body);
	}

	authorBooks(body) {
		return new Promise((resolve, reject) => {
			this.scs.http$('GET', `/api/books/byOwner/${body.authorId}`, null, null).subscribe((result: any) => {
				if (!result.success) {
					return reject(result.message);
				}

				this.booksService.setBooks(result.books);
				return resolve(result.books);
			});
		});
	}
}
